import React from 'react';

import type { Icon as PayloadIconType } from '../../graphql/generated/schema';
import { Icon_Size } from '../../graphql/generated/schema';
import type { IconType } from '../../components';
import { Icon as IconComponent } from '../../components';
import colors from '../../styles/colors/index.module.scss';
import styles from './styles.module.scss';

export const IconBlock: React.FC<PayloadIconType> = ({
  icon,
  size,
  color,
}) => (
  <IconComponent
    icon={(icon || 'xClassicRegular') as IconType}
    fill={(() => {
      switch (color) {
        case 'primary':
          return colors.primary;
        case 'secondary':
          return colors.secondary;
        default:
          return undefined;
      }
    })()}
    className={styles.icon}
    size={(() => {
      switch (size) {
        // eslint-disable-next-line camelcase
        case Icon_Size.Small:
          return 20;
        // eslint-disable-next-line camelcase
        case Icon_Size.Medium:
          return 32;
        // eslint-disable-next-line camelcase
        case Icon_Size.Large:
          return 48;
        default:
          return 20;
      }
    })()}
  />
);
